const panel = () => {
	document.getElementById('q_txt').addEventListener('keyup', panelTable, !1);
	panelTable();
};
const panelTable = () => {
	let tabla = document.getElementById('bodyTable');
	let _q = document.getElementById('q_txt').value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	let _tot = 0;
	//console.log(_q);
	while( tabla.firstChild ) {
		tabla.removeChild( tabla.firstChild );
	}
	for(let i in _data) {
		if(_q == '') {
			tabla.appendChild(addRowPanel(_data[i], tabla.dataset.sessiontype));
			_tot++;
		} else {
			if(_data[i]._label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(_q) >= 0) {
				tabla.appendChild(addRowPanel(_data[i], tabla.dataset.sessiontype));
				_tot++;
			}
		}
	}
	document.getElementById('stats_txt').innerHTML = `${_tot} Doctores`;
};
const addRowPanel = (_d, _sessiontype) => {
	
	let meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

	let _digi_date = (_d._date_digi == '0') ? '' : new Date(_d._date_digi * 1000);
	let _visi_date = (_d._date_visit == '0') ? '' : new Date(_d._date_visit * 1000);
	let _digi_date_str = '';
	let _visi_date_str = '';

	if(_digi_date != '') {
		_digi_date_str = _digi_date.getDate() + '/' + meses[_digi_date.getMonth()] + '/' + _digi_date.getFullYear();
		// _digi_date = _digi_date.getDate() + '/' + meses[_digi_date.getMonth()] + '/' + _digi_date.getFullYear() + ' '+_digi_date.getHours() + ':' + _digi_date.getMinutes();
	}
	if(_visi_date != '') {
		_visi_date_str = _visi_date.getDate() + '/' + meses[_visi_date.getMonth()] + '/' + _visi_date.getFullYear();
	}

	let tdArr = new Array();

	tdArr.push(createCustomElement('td',{'class':'text-muted small'},[_d._id]));
	tdArr.push(createCustomElement('td',{},[_d._label]));
	tdArr.push(createCustomElement('td',{},[_d._zone]));
	tdArr.push(createCustomElement('td',{},[_d._location]));
	tdArr.push(createCustomElement('td',{},[_d._visitor]));

	if(_sessiontype == 1) {
		tdArr.push(createCustomElement('td',{'class':'small'},[_digi_date_str]));
		tdArr.push(createCustomElement('td',{'class':'small'},[_visi_date_str]));
	} else {
		const now = new Date();
		
		if(_digi_date_str != '') {
			if(_digi_date.getMonth() == now.getMonth()) {
				tdArr.push(createCustomElement('td',{'class':'small'},[_digi_date_str]));
			} else {
				tdArr.push(createCustomElement('td',{'class':'small'},['']));
			}
		} else {
			tdArr.push(createCustomElement('td',{'class':'small'},['']));
		}
		
		if(_visi_date_str != '') {
			if(_visi_date.getMonth() == now.getMonth()) {
				tdArr.push(createCustomElement('td',{'class':'small'},[_visi_date_str]));
			} else {
				tdArr.push(createCustomElement('td',{'class':'small'},['']));
			}
		} else {
			tdArr.push(createCustomElement('td',{'class':'small'},['']));
		}
	}
	tdArr.push(
		createCustomElement('td',{},[
				createCustomElement('a',{'href':'det.php?id='+_d._id},[
					createCustomElement('i',{'class':'fas fa-folder-plus'})
				])
			])
		);
	return createCustomElement('tr',{}, tdArr);

};